import { motion } from 'framer-motion'

export default function MultiHover({ inputString }) {
  return (
    <span className='green'>
      { Array.from(inputString).map( (letter, index) =>
        <HoverLetter 
          key={ `${ letter }-${ index }`}
          letter={ letter } />
      ) }
    </span>
  )
}

function HoverLetter({ letter }) {
  const colors = [ '#6706ff', '#00f', 'red', 'yellow' ];
  const randomColor = colors[ Math.floor(Math.random() * colors.length) ];

  return (
    <motion.span
      style={{ cursor: 'pointer' }}
      whileHover={{ scale: 1.3, color: randomColor }}>
      { letter }
    </motion.span>
  )
}